import * as types from '../mutations-types'
import { getStaticHeatmap, getDynamicHeatmap } from '../../utils/api'

// STATE
const state = {
  showHeatMapDialog: false
}

// GETTERS
const getters = {
  showHeatMapDialog: state => state.showHeatMapDialog
}

// MUTATIONS
const mutations = {
  [types.SET_HEAT_MAP_DIALOG](state, value) {
    state.showHeatMapDialog = value
  }
}

// ACTIONS
const actions = {
  getStaticHeatmap({commit}, payload) {
    return new Promise(async(resolve, reject) => {
      try {
        await getStaticHeatmap(payload)
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            reject(new Error(error.response))
          })
      } catch (error) {
        console.error(error)
        reject(new Error(error.response))
      }
    })
  },
  getDynamicHeatmap({commit}, payload) {
    return new Promise(async(resolve, reject) => {
      try {
        await getDynamicHeatmap(payload)
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            reject(new Error(error.response))
          })
      } catch (error) {
        console.error(error)
        reject(new Error(error.response))
      }
    })
  },
  setHeatMapDialog({commit}, value) {
    commit(types.SET_HEAT_MAP_DIALOG, value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/heatmap.js